import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from "./redux/reducers/rootReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore() {
    return createStore(
        rootReducer,
        {
            auth: {
                user: localStorage.getItem('vlmToken'),
                userData: JSON.parse(localStorage.getItem('vlmUserData'))
            }
        },
        composeEnhancers(
            applyMiddleware(thunk)
        )
    );
}